const $ = jQuery.noConflict();

class Slider {
	constructor(selector, args = {}) {
		this.selector = selector;
		this.args     = args;
	}

	getDefaultSlickSettings() {
		return {
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			speed: 600,
		};
	}

	/**
	 * Override our default slick settings with args provided to the class.
	 */
	getSlickSettings() {
		return Object.assign( {}, this.getDefaultSlickSettings(), this.args );
	}

	init() {
		let settings = this.getSlickSettings();

		$( this.selector ).slick( settings );

		// TODO: Check is it required?
		// $( this.selector ).on('setPosition', () => {
		// $( this.selector ).find('figcaption').each((i, item) => {
		// const caption = $(item);
		// const width = caption.closest('figure').find('img').width();
		// caption.css('max-width', width > 0 ? `${width}px` : '');
		// });
		// });
	}

	refresh(sel) {
		if ( ! $( this.selector ).length) {
			return;
		}
		$( sel ).slick( 'refresh' );
	}
}

const SimpleSlider           = new Slider( '.gallery-slider__slider' );
const TestimonialSlider      = new Slider(
	'.testimonial-slider',
	{
		adaptiveHeight: true
	}
);
const FluidSlider            = new Slider(
	'.gallery-slider__slider-fluid',
	{
		centerMode: true,
		variableWidth: true,
	}
);
const HomeHeroSlider         = new Slider(
	'.block-home-hero__slider',
	{
		dots: true,
		arrows: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 5000,
	}
);
const HomeValueSlider        = new Slider(
	'.block-homepage-value__features',
	{
		dots: true,
		arrows: false,
		mobileFirst: true,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
		  {
				breakpoint: 991,
				settings: "unslick"
			}
		]
	}
);
const BecomeInstructorSlider = new Slider(
	'.block-homepage-become-instructor__team-cards',
	{
		dots: true,
		arrows: false,
		mobileFirst: true,
		variableWidth: true,
		centerMode: true,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					centerMode: false,
					variableWidth: false,
				}
			},
		  {
				breakpoint: 991,
				settings: "unslick"
			}
		]
	}
);
const LatestPostsSlider            = new Slider(
	'.block-latest-blog-posts__post-wrapper',
	{
		dots: true,
		arrows: false,
		mobileFirst: true,
		variableWidth: true,
		centerMode: true,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
		  {
				breakpoint: 991,
				settings: "unslick"
			}
		]
	}
);
const HomeExpeditionsSlider  = new Slider(
	'.block-alternative-image-links__slider',
	{
		dots: true,
		arrows: false,
		mobileFirst: true,
		responsive: [
		  {
				breakpoint: 991,
				settings: "unslick"
			}
		],
	}
);
const RelatedBlogPostsSlider = new Slider(
	'.block-related-blog-posts__cards-row',
	{
		dots: true,
		fade: true,
		arrows: false,
		mobileFirst: true,
		autoplay: true,
		autoplaySpeed: 5000,
	}
);
const CurrentOpenPositions   = new Slider(
	'.block-current-open-positions__slider',
	{
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				},
			}
		]
	}
)
export { SimpleSlider, TestimonialSlider, FluidSlider, HomeHeroSlider, HomeValueSlider, HomeExpeditionsSlider, BecomeInstructorSlider, LatestPostsSlider, RelatedBlogPostsSlider, CurrentOpenPositions };
